/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VisionSdkSubmitResponse } from '../../models/vision-sdk-submit-response';

export interface VisionSdkSubmitPost$Params {
}

export function visionSdkSubmitPost(http: HttpClient, rootUrl: string, params?: VisionSdkSubmitPost$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<VisionSdkSubmitResponse>> {
  const rb = new RequestBuilder(rootUrl, visionSdkSubmitPost.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<VisionSdkSubmitResponse>;
    })
  );
}

visionSdkSubmitPost.PATH = '/VisionSdk/Submit';
